export default "__VITE_ASSET__srzVgjUS__"